// removed by extract-text-webpack-plugin
module.exports = {"content":"Layout__content__2uzgd"};


//////////////////
// WEBPACK FOOTER
// ./src/hoc/Layout/Layout.css
// module id = 110
// module chunks = 3